import styled from 'styled-components';
import { StyledDiv } from '../../Theme/CommonStyled';

export const StyledFilter = styled(StyledDiv)`
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  color: ${({ theme }): string => theme.colors.normalText};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  padding: 10px 16px;
  border-radius: ${({ theme }): string => theme.radii.xl};
  width: 50%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
